export default "__VITE_ASSET__DR6zjLob__"